import React from 'react';
import LinkImage from "../../assets/images/u21.png";
import './style.scss';

class Title extends React.Component {

	render() {
		let isBT = this.props.isBT;
		let isFullPage = this.props.isFullPage ?? true;
		let displayBlackTriangle = 'blacktriangle-hide';
		if (isBT) { displayBlackTriangle = 'blacktriangle-show'; }
		let btPath = `${process.env.REACT_APP_CDN_BASEPATH}24BT.png`;
		let containerClass = isFullPage ? 'title-component app-row-full' : 'title-component'
		containerClass += ' ' + this.props.className;
		return (
			<div id={this.props.id ?? ''} className={containerClass}>
				<div className={this.props.piId ? "page-title link-title" : "page-title"}>
					{this.props.piId ? ((
						<a
							className="productLink"
							target="_blank"
							rel="noopener noreferrer"
							href={`${window.location.origin}/pi/${this.props.documentId}`}
						>
							<span>
								<h1>
									<div className="link-text">
										<img className={displayBlackTriangle + " inline"} src={btPath} width="24" height="24" alt="black triangle" />
										{this.props.title}
										<img className="link-icon" src={LinkImage} width="22" height="22" alt="link icon" />
									</div>
								</h1>
							</span>
						</a>
					)
					) : (
						<h1>
							<img className={displayBlackTriangle} src={btPath}
								width="24" height="24" alt="black triangle" />
							{this.props.title}
						</h1>
					)}
				</div>
			</div>
		);
	}
}

Title.defaultProps = {
	title: ''
};

export default Title;